import { NotFoundError } from '@cian/peperrors/shared';
import { TGetNewbuildingsForDeveloperCardResponse } from '../../../repositories/newbuilding-search/v1/get-newbuildings-for-developer-card';

export const assertNotFoundError = (response: TGetNewbuildingsForDeveloperCardResponse): void => {
  if (response.statusCode !== 200) {
    return;
  }

  const newbuildingsNotFound = !(response && response.response && response.response.newbuildings);

  if (!newbuildingsNotFound) {
    return;
  }

  throw new NotFoundError({
    domain: 'src/shared/services/getNewBuildings/getNewBuildings.ts',
    message: 'Empty newbuildings data',
  });
};
